import React, { useEffect } from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import PropTypes from 'prop-types';
import { object, string, date } from 'yup';
import { SelectInput } from '../../../Helpers/Inputs';
import { InForceLedgerOptions } from '../../SelectOptions';
import BackNextButton from '../../../Common/BackNextButton';

export default function InForceLedger(props) {

    const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
        validationSchema: InForceLedger.ValidationSchema,
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });

    const handleValueChange = (field, value) => {  
            setValue(field, value);
            props.onFieldChange(field, value);
            triggerValidation(field);
    };

    useEffect(() => {
        // manually register fields for validation that don't play nice with react-hook-form register
        register({ name: 'inForceLedgerType' });
        setValue('inForceLedgerType', props.formState.inForceLedgerType);

    }, [register]);

   const handleOnSubmit = () =>{
      props.clearAllSession();
      props.onNext();
   }

    return (
        <Container fluid className='border-class'>
            <form onSubmit={handleSubmit(handleOnSubmit)}>
                <Row className="justify-content-center pt-4">
                    <Col lg={4} className="pt-3">                            
                        <Form.Group>
                            <h6>Do You Have an In-Force Ledger?</h6>
                            <SelectInput
                                name="inForceLedgerType"
                                id="inForceLedgerType"
                                value={props.formState.inForceLedgerType}
                                onChange={(e) => handleValueChange('inForceLedgerType', e.target.value)}
                                label="Select One"
                                inputRef={register}
                                selectOptions={InForceLedgerOptions()}
                                errors={errors && errors.inForceLedgerType}
                            />
                        </Form.Group>                     
                    </Col>
                </Row>
                <BackNextButton onBack={props.onBack} />
            </form>
        </Container >
    )
}

InForceLedger.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
};

InForceLedger.ValidationSchema = object().shape({
    inForceLedgerType: string().required("This field is required."),
});

InForceLedger.DefaultFormState = (prefill = false) => {
    return {
        inForceLedgerType:''
    }
};




// WEBPACK FOOTER //
// ./src/components/PolicyReview/PermReview/steps/InForceLedger.js